export default __webpack_public_path__ + "static/media/seashell3.72999879.svg";